import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SignalRMethods } from 'src/app/enums/signalR-methods.enum';
import { Progress } from 'src/app/models/general/progress.model';
import { CompanyService, StateService } from 'src/app/services';
import { MainHubService } from 'src/app/services/mainHubService.service';
import { ErrorMessageService } from 'src/app/shared/services';

@Component({
  selector: 'app-company-page',
  templateUrl: './company-page.component.html',
  styleUrl: './company-page.component.scss'
})
export class CompanyPageComponent {
  
  constructor(private mainHubService: MainHubService,
              private companyService: CompanyService,
              private stateService: StateService,
              private msgService: ErrorMessageService,
              private translate: TranslateService) {
  }

  public calculateResults() {
      
    const connectionId = this.mainHubService.clientId;
     
    this.stateService.showIndeterminateSpinner();
      //this.testSpinner();
  
      this.mainHubService.connection.on(SignalRMethods.StatusChangeProgress, (data: Progress) => {
        const progress = Math.round( data.itemIndex / data.total * 100 );
  
        const msg = this.msgService.getErrorMessage(data.actionCode);
        const msgText = msg ? this.translate.instant(msg.translationKey) : '';
  
        this.stateService.showDeterminateSpinner(progress, msgText);
      });
  
      this.companyService.calculateResults(connectionId).subscribe({ 
        next: (data) => {
        
        this.stateService.hideSpinner();
      }, error: (err: any) => {
        
        this.stateService.hideSpinner();
      }, complete: () => {
        this.mainHubService.connection.off(SignalRMethods.StatusChangeProgress);
      }});
        
  }
  
}
